"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.processCalendarTxns = exports.getAMChartData = exports.getGroupedRecentAndFutureAccountTransactions = exports.getDateGroupedTransactions = exports.futureFilteredTxns = exports.getProjectedTxnList = exports.transactionListMetrics = exports.getRecentTransactions = exports.getTransactionsWithCategorySuggestions = exports.getTransactionListForAccountIds = void 0;
const re_reselect_1 = require("re-reselect");
const reselect_1 = require("reselect");
const luxon_1 = require("luxon");
const immutable_1 = require("immutable");
const feature_flags_1 = require("companion-app-components/flux/feature-flags");
const core_1 = require("companion-app-components/utils/core");
const accounts_1 = require("companion-app-components/flux/accounts");
const categories_1 = require("companion-app-components/flux/categories");
const transactions_1 = require("companion-app-components/flux/transactions");
const utils_1 = require("utils/utils");
const optimalCacheManager_1 = require("data/optimalCacheManager");
const memoizeWithKey_1 = require("utils/memoizeWithKey");
const objectToKeyUtils_1 = require("utils/objectToKeyUtils");
const AmountField_1 = require("components/QuickenControls/AmountField");
const selectors_1 = require("data/transactions/selectors");
const selectors_2 = require("data/accountBalances/selectors");
const utils_2 = require("data/transactions/utils");
const optimalCacheFunctions_1 = require("data/transactionList/optimalCacheFunctions");
const preferencesSelectors = __importStar(require("data/preferences/selectors"));
const selectors_3 = require("data/payees/selectors");
const constants_1 = require("components/ProjectedBalances/constants");
const grouping_1 = require("./grouping");
const utils_3 = require("./utils");
const sorting_1 = require("./sorting");
const log = (0, core_1.getLogger)('data/transactionList/selectors');
//-----------------------------------------------
//-----------------------------------------------
// getTransactionListForAccountIds
//
// This selector expects the following properties:
//   - an array of accountIds
//   - sortBy property
//   - sortOrder property
//   - filter function that if defined is provided the transaction list to filter. null
//     functions as the identity filter (show all)
//
// Returns an immutable list of transactions from accounts specified by the
// accountIds array.
exports.getTransactionListForAccountIds = (0, reselect_1.createSelector)((state, props) => props.accountIds, (state, props) => props.sortBy || 'date', (state, props) => props.sortOrder || 'sortDescending', (state, props) => props.filterFn, (state, props) => props.overrideTxns, (state, props) => props.reminderSetting || 0, (state, props) => props.id, selectors_1.getTransactionsStore, accounts_1.accountsSelectors.getAccountsById, selectors_1.getTransactionsByAccountId, selectors_1.getTransactionsByAccountIdsSelectors, selectors_2.getBalancesByAccountId, feature_flags_1.featureFlagsSelectors.getFeatureFlags, preferencesSelectors.getRunningBalanceExcludeAccountIds, selectors_1.getIsLoading, accounts_1.accountsSelectors.getIsLoading, 
// eslint-disable-next-line wrap-iife
(function combinerClosure() {
    return (accountIds, sortBy, sortOrder, filterFn, overrideTxns, reminderSetting, id, transactionsStore, accountsById, transactionsByAccountIds, transactionsByAccountIdsSelectors, balancesById, featureFlags, runningBalanceExcludeAccountIds, transactionsAreLoading, accountsAreLoading) => {
        const cacheObject = {
            name: 'txList',
            accountIds,
            sortBy,
            sortOrder,
            filterFn,
            overrideTxns,
            reminderSetting,
            id,
            accountsById,
            transactionsByAccountIdsSelectors,
            featureFlags,
        };
        const strictCacheObject = Object.assign(Object.assign({}, cacheObject), { transactionsByAccountIds,
            balancesById });
        if (!transactionsAreLoading && !accountsAreLoading) {
            // if we are forcing a cache break, then skip cache processing, and go straight to regneeration,
            const cachedValues = (0, optimalCacheManager_1.getOptimalCacheFromObject)(transactionsStore, 'txList', cacheObject, strictCacheObject, (oldTxn, newTxn) => (0, optimalCacheFunctions_1.optimalCacheCompareFn)(oldTxn, newTxn, sortBy, filterFn), (cache, newTxn) => (0, optimalCacheFunctions_1.optimalCacheProcessFn)(cache, newTxn, filterFn), 10);
            if (cachedValues)
                log.debug('===================== TXLIST CACHE HIT =======================');
            if (cachedValues)
                return cachedValues;
        }
        log.debug('===================== TXLIST CACHE MISS =======================');
        let accountIdsList = accountIds;
        if (!accountIds || accountIds.length === 0) {
            accountIdsList = accountsById.map((x) => x.id).toList();
        }
        let transactionsForAccountIds;
        if (overrideTxns) {
            transactionsForAccountIds = overrideTxns;
        }
        else {
            transactionsForAccountIds = (0, immutable_1.List)();
            accountIdsList.forEach((accountId) => {
                const acct = accountsById.get(accountId);
                // @ts-expect-error ts(2554) - FIXME: Expected 4 arguments, but got 3. An argument for 'state' was not provided.
                const hideTxns = accounts_1.accountsUtils.transactionsNotSupportedForAccountId(accountId, featureFlags.get('hideLoanTransactions'), featureFlags.get('hideConnectedLoanTransactions'));
                if (acct && !hideTxns) {
                    const transactionsForAccountIdSelector = transactionsByAccountIdsSelectors.get(accountId);
                    const transactionsForAccountId = transactionsForAccountIdSelector(transactionsByAccountIds);
                    // Filter out reminder transactions as appropriate
                    let filteredTransactions = transactionsForAccountId;
                    if (!featureFlags.get('scheduledTransactionsInRegister')) {
                        filteredTransactions = transactionsForAccountId.filter((txn) => !(0, utils_2.isUnacceptedScheduledTxn)(txn));
                    }
                    else {
                        // we use the reminderSetting to determine which unaccepted scheduled transactions we show
                        let acctReminderSetting = reminderSetting;
                        if (acctReminderSetting === 'account' && acct) {
                            acctReminderSetting = accounts_1.accountsUtils.getReminderSettingInDays(acct.recurringTxn);
                        }
                        filteredTransactions = filteredTransactions.filter((txn) => (!(0, utils_2.isUnacceptedScheduledTxn)(txn) || (0, selectors_2.includeRecurringTxn)(txn, acctReminderSetting, transactionsForAccountId)) &&
                            !(0, utils_2.isUnAcceptedBankPendingTxn)(acct, txn));
                    }
                    transactionsForAccountIds = transactionsForAccountIds.concat(filteredTransactions);
                }
            });
        }
        let filteredTxns = filterFn ? filterFn(transactionsForAccountIds) : transactionsForAccountIds;
        if (sortBy === 'reviewed') {
            filteredTxns = filteredTxns.filter((txn) => (sortOrder === 'ascending' ? !txn.isReviewed : txn.isReviewed));
        }
        // if the app is using the upcomingSection, then filter out any future transactions
        // and DUE/OVERDUE scheduled transactions
        // but do not do this if caller sent in their own txn list (override txns)
        if (featureFlags.get('upcomingSection') && !overrideTxns) {
            filteredTxns = filteredTxns.filter((txn) => luxon_1.DateTime.fromISO(txn.postedOn) <= luxon_1.DateTime.now() && !(0, utils_2.isUnacceptedScheduledTxn)(txn));
        }
        const sortedTxns = (0, sorting_1.sortTransactions)(filteredTxns, sortBy, sortOrder, featureFlags);
        let txnsWithBalances = sortedTxns;
        if (balancesById.size > 0 && accountIdsList.size === 1 && Number(accountIdsList.first()) !== 0) {
            const balObj = balancesById.get(accountIdsList.first());
            const endingBalance = balObj ? balObj.endingBalance : 0;
            const isExcludePendingTxn = runningBalanceExcludeAccountIds === null || runningBalanceExcludeAccountIds === void 0 ? void 0 : runningBalanceExcludeAccountIds.includes(accountIdsList.first());
            txnsWithBalances = (0, utils_3.calcRunningBalances)(sortedTxns, sortBy, sortOrder, endingBalance, isExcludePendingTxn);
        }
        let groupedTxns;
        switch (sortBy) {
            case 'date':
                groupedTxns = (0, grouping_1.groupTxnListByDate)(txnsWithBalances, featureFlags, true);
                groupedTxns = groupedTxns.sortBy((x, k) => k, (a, b) => {
                    if (a === b)
                        return 0;
                    return a < b ? -1 : 1;
                });
                groupedTxns = sortOrder === 'descending' ? groupedTxns.reverse() : groupedTxns;
                break;
            case 'category':
            case 'payee':
            case 'check':
                groupedTxns = (0, grouping_1.groupTxnListByString)(txnsWithBalances, sortBy);
                break;
            case 'reviewed':
                groupedTxns = (0, grouping_1.groupTxnListByDate)(txnsWithBalances, featureFlags, true);
                break;
            case 'status':
                groupedTxns = (0, grouping_1.groupTxnListByString)(txnsWithBalances, 'state');
                break;
            case 'amount':
                groupedTxns = (0, grouping_1.groupTxnListByAmount)(txnsWithBalances);
                break;
            default:
                groupedTxns = (0, grouping_1.groupTxnListByString)(txnsWithBalances, 'payee');
        }
        if (!transactionsAreLoading && !accountsAreLoading) {
            (0, optimalCacheManager_1.setOptimalCacheFromObject)(transactionsStore, 'txList', cacheObject, strictCacheObject, groupedTxns, 10);
        }
        return groupedTxns;
    };
})());
/*
 * GetTransactionsWithCategoyrSuggestions
 *
 * Measured with a reasonably large dataset, this takes 1 to 2ms
 */
exports.getTransactionsWithCategorySuggestions = (0, re_reselect_1.createCachedSelector)((state, props) => props.accountIds, selectors_1.getTransactionsByAccountId, selectors_3.getPayeesForAccounts, accounts_1.accountsSelectors.getAccountsById, selectors_1.getTransactionsByAccountIdsSelectors, (accountIds, transactionsByAccountIds, payeeList, accountsById, transactionsByAccountIdsSelectors) => {
    const pt = luxon_1.DateTime.now().toMillis();
    let accountIdsList = accountIds;
    if (!accountIds || accountIds.length === 0) {
        accountIdsList = accountsById.map((x) => x.id).toList();
    }
    let transactionsForAccountIds;
    transactionsForAccountIds = (0, immutable_1.List)();
    accountIdsList.forEach((accountId) => {
        const acct = accountsById.get(accountId);
        if (acct && acct.type !== 'LOAN') {
            const transactionsForAccountIdSelector = transactionsByAccountIdsSelectors.get(accountId);
            const transactionsForAccountId = transactionsForAccountIdSelector(transactionsByAccountIds);
            transactionsForAccountIds = transactionsForAccountIds.concat(transactionsForAccountId);
        }
    });
    const ret = transactionsForAccountIds.filter((txn) => { var _a; return (0, utils_2.isUncategorizedTxn)(txn) && payeeList.has((_a = (txn.payee || '')) === null || _a === void 0 ? void 0 : _a.toLowerCase()); });
    log.debug(`RETURNING CAT SUGGESTIONS, total time ${luxon_1.DateTime.now().toMillis() - pt}`);
    return ret;
})({
    keySelector: (_, props) => `${props.accountIds}`,
    cacheObject: new re_reselect_1.LruObjectCache({ cacheSize: 3 }),
});
/*
 * GetRecentTransactions
 */
exports.getRecentTransactions = (0, reselect_1.createSelector)((state) => accounts_1.accountsSelectors.getLoadPending(state) || categories_1.categoriesSelectors.getLoadPending(state) || (0, selectors_1.getLoadPending)(state), accounts_1.accountsSelectors.getAccountsById, selectors_1.getTransactionsById, categories_1.categoriesSelectors.getCategoriesById, selectors_1.getTransactionsStore, accounts_1.accountsSelectors.getPendingTxnExcludedAccountIds, (isLoadPending, accountByIds, txnList, categoriesById, transactionsStore, pendingTxnExcludedAccountIds) => {
    var _a;
    if (isLoadPending) {
        return (0, immutable_1.List)([]);
    }
    const pt = luxon_1.DateTime.now().toMillis();
    const cacheObject = {
        categoriesById,
        pendingTxnExcludedAccountIds,
    };
    const strictCacheObject = Object.assign(Object.assign({}, cacheObject), { txnList });
    const cachedValues = (0, optimalCacheManager_1.getOptimalCacheFromObject)(transactionsStore, 'recentTransactions', cacheObject, strictCacheObject, optimalCacheFunctions_1.optimalCacheCompareFnPostedOn, // uses same comparator as Proj Txn
    optimalCacheFunctions_1.optimalCacheProcessFnTxnList, // uses same "grouped" process function as getTransactionList
    2);
    if (cachedValues) {
        return cachedValues;
    }
    // ======== FOR RECENT TX. CARD (SIMPLIFI) =============
    const filterByDate = false;
    let returnObject = null;
    const [...idsToUse] = ((_a = accountByIds.filter((account) => !account.isExcludedFromReports)) === null || _a === void 0 ? void 0 : _a.keys()) || [];
    let txns = txnList.filter((txn) => {
        const startDate = luxon_1.DateTime.now().minus({ months: 2 });
        const endDate = luxon_1.DateTime.now();
        const txnDate = luxon_1.DateTime.fromISO(txn.postedOn);
        const isValid = transactions_1.transactionsUtils.isSplitTxn(txn)
            ? !(txn.source && txn.source === 'SCHEDULED_TRANSACTION_PENDING') && idsToUse.includes(txn.accountId)
            : txn &&
                !(txn.source && txn.source === 'SCHEDULED_TRANSACTION_PENDING') &&
                txn.coa &&
                txn.coa.type &&
                txn.coa.type !== 'BALANCE_ADJUSTMENT' &&
                (!transactions_1.transactionsUtils.isTransferTxn(txn) || Number(txn.amount) < 0) &&
                !((0, utils_2.isBankOwnedPending)(txn) && pendingTxnExcludedAccountIds.includes(txn.accountId)) &&
                idsToUse.includes(txn.accountId);
        const beforeToday = txnDate < endDate;
        return isValid && (filterByDate ? beforeToday && txnDate > startDate : beforeToday) && !(0, utils_2.isC2RTransaction)(txn);
    });
    txns = txns.sort((a, b) => (0, utils_2.transactionsSortFunction)(b, a));
    returnObject = txns.toList().slice(0, 5);
    log.debug(`RETURNING RECENT TXNS, total time ${luxon_1.DateTime.now().toMillis() - pt}`);
    (0, optimalCacheManager_1.setOptimalCacheFromObject)(transactionsStore, 'recentTransactions', cacheObject, strictCacheObject, returnObject, 2);
    return returnObject;
});
exports.transactionListMetrics = (0, re_reselect_1.createCachedSelector)((state, transactionList) => transactionList, (txnList) => {
    let numTxns = 0;
    let sumTxns = 0;
    let earliestDate = luxon_1.DateTime.now();
    let reviewedCount = 0;
    let hasScheduledInstances = false;
    txnList.forEach((section, _) => {
        numTxns += section.size;
        section.forEach((txn) => {
            sumTxns += Number(txn.amount);
            const postedDate = luxon_1.DateTime.fromISO(txn.postedOn);
            if (postedDate < earliestDate) {
                earliestDate = postedDate;
            }
            reviewedCount += txn.isReviewed ? 1 : 0;
            hasScheduledInstances = hasScheduledInstances || (0, utils_2.isUnacceptedScheduledTxn)(txn);
        });
    });
    return { numTxns, sumTxns, earliestDate, reviewedCount, hasScheduledInstances };
})({
    keySelector: (_, props) => (props.accountIds ? props.accountIds.toString() : 'all'),
    cacheObject: new re_reselect_1.LruObjectCache({ cacheSize: 10 }),
});
// ## ================================================================================================ ##
//
// ##                              Chris Selectors   (OH NO)  RUN TO THE HILLS!!!! RUN FOR YOUR LIFE!! ##  (Iron Maiden) \,,/
//
// ## ================================================================================================ ##
// let hackGlobal;
exports.getProjectedTxnList = (0, reselect_1.createSelector)((state, props) => props.accountIds, (state, props) => props.overrideTxns, (state, props) => props.maxTxns, (state, props) => props.endDate, accounts_1.accountsSelectors.getAccountsById, (state, props) => (0, selectors_1.getTransactionsByAccountId)(state, { txnTypes: props.txnTypes || selectors_1.txnTypesDefault | selectors_1.TxnTypes.REFUND_VIRTUAL_TXN }), selectors_1.getTransactionsByAccountIdsSelectors, feature_flags_1.featureFlagsSelectors.getFeatureFlags, selectors_1.getTransactionsStore, 
// eslint-disable-next-line wrap-iife
(function combinerClosure() {
    return (accountIds, overrideTxns, maxTxns, endDate, accountsById, transactionsByAccountId, transactionsByAccountIdsSelectors, featureFlags, transactionsStore) => {
        const cacheObject = {
            name: 'projTxnList',
            accountIds,
            overrideTxns,
            accountsById,
            transactionsByAccountIdsSelectors,
            featureFlags,
            endDate,
        };
        const strictCacheObject = Object.assign(Object.assign({}, cacheObject), { transactionsByAccountId });
        // console.log("GETTING CACHE OBJECT GET PROJECTED TXN LIST", cacheObject, strictCacheObject);
        // console.log("hash code for transactions ", transactionsByAccountId?.hashCode());
        const cachedValues = (0, optimalCacheManager_1.getOptimalCacheFromObject)(transactionsStore, 'projTxnList', cacheObject, strictCacheObject, optimalCacheFunctions_1.optimalCacheCompareFnPostedOn, optimalCacheFunctions_1.optimalCacheProcessFnTxnList, 10);
        // console.log("CACHED VALUES ARE ", cachedValues);
        // console.log("RETURNING CACHE ", cachedValues?.hashCode(), hackGlobal?.hashCode(), cachedValues === hackGlobal);
        if (cachedValues) {
            if (maxTxns && cachedValues.size > maxTxns) {
                return cachedValues.slice(0, maxTxns);
            }
            return cachedValues;
        }
        const sortBy = 'date';
        const sortOrder = 'ascending';
        let accountIdsList = accountIds;
        if (!accountIds || accountIds.length === 0) {
            accountIdsList = accountsById.map((account) => account.id).toList();
        }
        // TODO: memoize the getFutureTxns call
        const transactionsForAccountIds = overrideTxns ||
            (0, utils_3.getFutureTxnsForAccountIds)({
                accountIdsList,
                accountsById,
                transactionsByAccountId,
                transactionsByAccountIdsSelectors,
                featureFlags,
            });
        let filteredTxnsForAccountIds = transactionsForAccountIds;
        if (endDate && transactionsForAccountIds.size > 0) {
            filteredTxnsForAccountIds = transactionsForAccountIds.filter((txn) => 
            // @ts-expect-error - FIXME: Object is possibly 'undefined' ts(2532)
            luxon_1.DateTime.fromISO(txn.postedOn).diff(luxon_1.DateTime.fromISO(endDate), 'days').toObject().days < 0);
        }
        let upcomingTxns = (0, sorting_1.sortTransactions)(filteredTxnsForAccountIds, sortBy, sortOrder);
        (0, optimalCacheManager_1.setOptimalCacheFromObject)(transactionsStore, 'projTxnList', cacheObject, strictCacheObject, upcomingTxns, 10);
        if (maxTxns && upcomingTxns.size > maxTxns) {
            upcomingTxns = upcomingTxns.slice(0, maxTxns);
        }
        return upcomingTxns;
    };
})());
/** *****************************************************************************************
 * HELPER FUNCTIONS
 ******************************************************************************************** */
// This selector is basically used for cache (could use memoize instead)
const futureFilteredTxns = (txns, date, schTxns) => txns.filter((txn) => {
    const txnDate = luxon_1.DateTime.fromISO(txn.postedOn);
    if (schTxns) {
        return ((txn.source === 'USER_ENTERED' && Number(txnDate.diff(luxon_1.DateTime.local(), 'days').toObject().days) >= 0) ||
            txn.source === 'SCHEDULED_TRANSACTION_PENDING');
    }
    return (txn.source === 'USER_ENTERED' || txn.source === 'SCHEDULED_TRANSACTION_PENDING' // adding this so we can have the 'waiting' button
    );
});
exports.futureFilteredTxns = futureFilteredTxns;
exports.getDateGroupedTransactions = (0, reselect_1.createSelector)((txns) => txns, (txns, date) => date, (txns, date, schTxns) => schTxns, 
// eslint-disable-next-line wrap-iife
(function combinerClosure() {
    return (txns, date, schTxns) => {
        const key = (0, objectToKeyUtils_1.getOrCreateStringFromObject)('dateGroupedTxns', { txns, date, schTxns }, 5, memoizeWithKey_1.memoizeWithKeyRetrieveCache);
        return (0, memoizeWithKey_1.memoizeWithKey)('dateGroupedTxns', () => { var _a; return (_a = (0, exports.futureFilteredTxns)(txns, date, schTxns)) === null || _a === void 0 ? void 0 : _a.groupBy((txn) => luxon_1.DateTime.fromISO(txn.postedOn).toISODate()); }, key, 5);
    };
})());
const getDateMap = (0, reselect_1.createSelector)((previousDays) => previousDays, (_, days) => days, (previousDays, days) => {
    const startDate = luxon_1.DateTime.local().minus({ days: previousDays });
    let dateMap = (0, immutable_1.OrderedMap)();
    let currentDate = startDate;
    let currentIndex = 0;
    while (currentIndex < days) {
        dateMap = dateMap.set(currentDate.toISODate(), currentIndex);
        currentDate = currentDate.plus({ days: 1 });
        currentIndex += 1;
    }
    dateMap = dateMap.set(currentDate.toISODate(), currentIndex);
    return dateMap;
});
exports.getGroupedRecentAndFutureAccountTransactions = (0, reselect_1.createSelector)(selectors_1.getTransactionsByAccountIdRaw, selectors_1.getTransactionsStore, (state, props) => props.dateRange, (txnsByAccountId, transactionsStore, dateRange) => {
    const endDate = luxon_1.DateTime.local().startOf('day').plus({ days: dateRange });
    const pastCutoff = luxon_1.DateTime.local().startOf('day').minus({ days: 10 });
    const cacheKey = (0, objectToKeyUtils_1.getOrCreateStringFromObject)('recent-grouped-txns', {
        name: 'recentAcctTxns',
        // @ts-expect-error - FIXME: Property ts does not exist on type DateTime
        pastCutoff: pastCutoff.ts,
        txnsByAccountId,
    }, 5, memoizeWithKey_1.memoizeWithKeyRetrieveCache);
    return (0, memoizeWithKey_1.memoizeWithKey)('recent-grouped-txns', () => {
        const todayTxnArr = []; // for due or overdue txns
        const groupedTxns = (0, immutable_1.Map)().withMutations((accountMapSetter) => {
            txnsByAccountId.forEach((account, key) => {
                const ungroupedTxns = account.filter((txn) => {
                    if (txn.id === txn.clientId) {
                        // filter out optimistically created manual transactions because they crash AMcharts
                        return false;
                    }
                    const refundState = (0, utils_2.getRefundState)(txn);
                    if (refundState === utils_2.RefundState.EXPECTED || refundState === utils_2.RefundState.OVERDUE) {
                        return true;
                    }
                    const txnDate = txn.postedOn && luxon_1.DateTime.fromISO(txn.postedOn);
                    const todayDate = luxon_1.DateTime.local().startOf('day');
                    const info = (0, utils_2.getTxnStateInfo)(txn);
                    if (info.status === 'DUE' || info.status === 'OVERDUE') {
                        if (txnDate < todayDate) {
                            todayTxnArr.push(txn);
                        }
                        return true;
                    }
                    return txnDate && txnDate < endDate && txnDate > pastCutoff;
                });
                const ret = ungroupedTxns === null || ungroupedTxns === void 0 ? void 0 : ungroupedTxns.groupBy((txn) => luxon_1.DateTime.fromISO(txn.postedOn).toISODate());
                accountMapSetter.set(key, ret);
            });
        });
        return {
            todayTxnArr,
            groupedTxns,
        };
    }, cacheKey, 5);
    // log.debug("REGENERATING RECENT ACCOUNT TRANSACTIONS", accountId);
    // Because of the way that the projected balances graph is situated, we want separation and grouping of transactions by account
});
exports.getAMChartData = (0, reselect_1.createSelector)((state, props) => getDateMap(constants_1.PAST_DAYS_NUMBER, props.dateRange + constants_1.PAST_DAYS_NUMBER), (state, props) => props.dateRange, (state, props) => (0, exports.getGroupedRecentAndFutureAccountTransactions)(state, { dateRange: props.dateRange }), selectors_2.getBalancesByAccountId, accounts_1.accountsSelectors.getAccountsById, selectors_1.getTransactionsById, selectors_1.getTransactionsStore, (dateMap, dateRange, groupedTxnObj, balancesById, accountsById, transactionsById, transactionsStore) => {
    // So we need to "recalc" if the amount or date changed, as this will change the actual values inside
    // of chartData, or could impact the sort order (and only way getRecent might return something different)
    // since we only return "ids", we don't have to process changes from optimal cache manager, but we do
    // use it for comparing all changes
    const cacheObject = {
        dateMap,
        dateRange,
        // accountIds,
        balancesById,
        accountsById,
    };
    // represents the resource I can optimize on
    const strictCacheObject = Object.assign(Object.assign({}, cacheObject), { transactionsById });
    const cachedValues = (0, optimalCacheManager_1.getOptimalCacheFromObject)(transactionsStore, 'amChartData', cacheObject, strictCacheObject, optimalCacheFunctions_1.optimalCacheCompareFnPostedOnAndAmount, // uses same comparator as Proj Txn
    (workingCache) => workingCache, // we don't bother altering the workingCache
    10);
    if (cachedValues) {
        log.debug('RETURNING CACHED VALUES for AmGraph');
        return cachedValues;
    }
    let index = 0;
    const groupedTxns = groupedTxnObj === null || groupedTxnObj === void 0 ? void 0 : groupedTxnObj.groupedTxns;
    const todayTxnArr = groupedTxnObj === null || groupedTxnObj === void 0 ? void 0 : groupedTxnObj.todayTxnArr; // due or overdue instances (they get added to today bullet)
    const accountsMap = (0, immutable_1.Map)().withMutations((accountMap) => {
        accountsById.forEach((account, accountId) => {
            let min = 0;
            const minArr = [];
            let max = 0;
            const maxArr = [];
            if (account.type === 'INVESTMENT') {
                return;
            }
            const credit = account.type === 'CREDIT' ? -1 : 1;
            const chartData = [];
            let currentBalance = 0;
            let todayBalance = 0;
            const balObj = balancesById === null || balancesById === void 0 ? void 0 : balancesById.get(accountId);
            currentBalance = balObj ? balObj.currentBalance : 0;
            todayBalance = balObj ? balObj.currentBalance : 0;
            const pastArr = [];
            let prevKey;
            let dateCount = 0;
            dateMap.forEach((value, key) => {
                var _a, _b, _c;
                const txnGroup = (_a = groupedTxns.get(accountId)) === null || _a === void 0 ? void 0 : _a.get(key);
                let noIncome = true;
                let noRefund = true;
                const isToday = key === luxon_1.DateTime.local().startOf('day').toISODate();
                // @ts-expect-error - FIXME: Object is possibly null ts(2531)
                const isPast = key < luxon_1.DateTime.local().startOf('day').toISODate();
                if (isPast) {
                    // add key to array
                    pastArr.unshift(key);
                }
                else {
                    if (isToday) {
                        // if we don't do it like this, the balances would be incorrect. You need to backtrack from today.
                        pastArr.forEach((dateVal) => {
                            var _a;
                            // pastArr contains only past dates, as we are using current balance, so to get the balance on past date we need to
                            // subtract the amount of the txns posted from Today. So adding a day to include these txns
                            const dateToBackTrack = luxon_1.DateTime.fromISO(dateVal).plus({ day: 1 }).toFormat('yyyy-MM-dd');
                            const group = (_a = groupedTxns.get(accountId)) === null || _a === void 0 ? void 0 : _a.get(dateToBackTrack);
                            if (group) {
                                group.forEach((txn) => {
                                    // minus instead of plus because we are going backwards
                                    if (txn.source !== 'SCHEDULED_TRANSACTION_PENDING') {
                                        todayBalance -= (0, utils_1.noNaN)(txn.amount);
                                    }
                                });
                            }
                            if (min > todayBalance * credit) {
                                min = todayBalance * credit;
                            }
                            if (max < todayBalance * credit) {
                                max = todayBalance * credit;
                            }
                            chartData.push({
                                balance: (todayBalance * credit).toFixed(2),
                                date: dateVal,
                                txns: null,
                                disabled: true,
                                noIncome: true,
                                noRefund: true,
                            });
                        });
                        chartData.reverse();
                    }
                    // this is so we have flat sections. Basically, we don't want to add anything to the chart data array
                    // unless there is a txn or if there is a previous blank piece of data next to a group with a transaction in order to keep the line flat
                    if (prevKey && txnGroup && !((_b = groupedTxns.get(accountId)) === null || _b === void 0 ? void 0 : _b.get(prevKey))) {
                        chartData.push({
                            balance: (currentBalance * credit).toFixed(2),
                            date: prevKey,
                            txns: null,
                            disabled: true,
                            noIncome: true,
                            noRefund: true,
                        });
                    }
                    if (txnGroup || isToday) {
                        const txnArr = [];
                        let showBulletForToday = false;
                        if (isToday) {
                            todayTxnArr.forEach((txn) => {
                                if (txn.accountId === accountId) {
                                    currentBalance += (0, utils_1.noNaN)(txn.amount);
                                    txnArr.push(txn);
                                    showBulletForToday = true; // show today bullet if there are due/overdue instances
                                }
                            });
                        }
                        txnGroup === null || txnGroup === void 0 ? void 0 : txnGroup.forEach((txn) => {
                            var _a;
                            if (!isToday || txn.source === 'SCHEDULED_TRANSACTION_PENDING') {
                                currentBalance += (0, utils_1.noNaN)(txn.amount);
                                txnArr.push(txn);
                                if (isToday) {
                                    showBulletForToday = true; // show today bullet if there are instances for today
                                }
                            }
                            if (categories_1.categoriesSelectors.isIncomeCat(null, ((_a = txn.coa) === null || _a === void 0 ? void 0 : _a.id) || '') && txn.source === 'SCHEDULED_TRANSACTION_PENDING') {
                                noIncome = false;
                            }
                            if ((0, utils_2.isRefundTxn)(txn) && txn.source === 'SCHEDULED_TRANSACTION_PENDING') {
                                noRefund = false;
                            }
                        });
                        if (isToday && !showBulletForToday) {
                            noIncome = true;
                            noRefund = true;
                        }
                        let txnHTML = '';
                        txnArr.forEach((txn) => {
                            txnHTML += `<div style="display: flex; justify-content: space-between; width: 100%; max-width: 200px;">
                              <span style="font-size: 12px;height: 15px;font-weight: 400;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;text-transform: capitalize; ">${txn.payee}</span>
                              <span style="font-size: 12px;height: 15px;font-weight: 400;">${(0, AmountField_1.formatNumber)(parseFloat(txn.amount.toString()), 'USD', '0,0.00', AmountField_1.ShowSignEnum.POSITIVE_ONLY)}</span>
                            </div>`;
                        });
                        chartData.push({
                            balance: (currentBalance * credit).toFixed(2),
                            date: key,
                            txns: txnHTML,
                            disabled: (isToday && !showBulletForToday) || !noIncome,
                            noIncome,
                            noRefund,
                            firstTxnId: ((_c = txnArr[0]) === null || _c === void 0 ? void 0 : _c.id) || '-1',
                        });
                    }
                    if (constants_1.RANGE_INDICES.indexOf(dateCount) !== -1) {
                        if (!txnGroup) {
                            chartData.push({
                                balance: (currentBalance * credit).toFixed(2),
                                date: key,
                                txns: null,
                                disabled: true,
                                noIncome: true,
                                noRefund: true,
                                firstTxnId: '-1',
                            });
                        }
                        minArr.push(min > 0 ? 0 : min);
                        maxArr.push(max < 0 ? 0 : max);
                    }
                    if (min > currentBalance * credit) {
                        min = currentBalance * credit;
                    }
                    if (max < currentBalance * credit) {
                        max = currentBalance * credit;
                    }
                }
                prevKey = key;
                dateCount += 1;
            });
            if (min > 0) {
                min = 0;
            }
            if (max < 0) {
                max = 0;
            }
            accountMap.set(accountId, {
                chartData,
                credit: credit === -1,
                min,
                max,
                name: account.name,
                index,
                minArr,
                maxArr,
            });
            index += 1;
        });
    });
    (0, optimalCacheManager_1.setOptimalCacheFromObject)(transactionsStore, 'amChartData', cacheObject, strictCacheObject, accountsMap, 10);
    return accountsMap;
});
exports.processCalendarTxns = (0, reselect_1.createSelector)((txns) => txns, (txns) => txns.groupBy(() => '9999-99:Pending'));
